document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.accordion').forEach((accordion) => {
        accordion.addEventListener('click', () => {
            const head = accordion.querySelector('.accordion__head');
            const body = accordion.querySelector('.accordion__body');

            const isOpen = head.classList.contains('active');

            if(isOpen) {
                head.classList.remove('active');
                body.style.maxHeight = '0px';
            } else {
                head.classList.add('active');
                body.style.maxHeight = `${body.scrollHeight}px`
            }
        })
    })

})